/* eslint-disable @next/next/no-before-interactive-script-outside-document */
import { Fragment } from 'react'
import Script from 'next/script'
import { useTranslation } from 'next-i18next'
import { useEffect } from 'react'
import env from '@/lib/env'

export function ProductionScripts(): React.ReactElement | null {
  const { i18n } = useTranslation()
  useEffect(() => {
    if (!env.IS_PROD) return
    const timer = setTimeout(() => {
      if (window.cwcCookieBanner) {
        window.cwcCookieBanner.unmountBanner()
        window.cwcCookieBanner.setLang(i18n.language)
        window.cwcCookieBanner.reinitializeBanner()
      }
    }, 300)
    return () => clearTimeout(timer)
  }, [i18n.language])
  return (
    <Fragment>
      <Script id="gtm" strategy="afterInteractive">
        {`(function(w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({
                'gtm.start': new Date().getTime(),
                event: 'gtm.js'
            });
            var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s),
                dl = l != 'dataLayer' ? '&l=' + l : '';
            j.async = true;
            j.src =
                'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
            f.parentNode.insertBefore(j, f);
          })(window, document, 'script', 'dataLayer', '${env.GTM_CONTAINER_ID}');`}
      </Script>
      <Script
        strategy="beforeInteractive"
        type="text/javascript"
        src="https://cookiecdn.com/cwc.js"
        defer={false}
      />
      <Script
        strategy="beforeInteractive"
        id="cookieWow"
        type="text/javascript"
        src={`https://cookiecdn.com/configs/${env.COOKIE_BANNER_ID}`}
        data-cwcid={env.COOKIE_BANNER_ID}
        defer={false}
      />
    </Fragment>
  )
}
